import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHtml5,
  faCss3,
  faReact,
  faJsSquare,
  faGitAlt,
  faNode,
} from "@fortawesome/free-brands-svg-icons";
import { faDatabase, faServer, faCode, faShieldAlt, faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import Img from "../../assets/images/typescript.jpeg";
import Loader from "react-loaders";

// Frontend skills
const frontendSkills = [
  {
    icon: <FontAwesomeIcon icon={faReact} color="#5ED4F4" />,
    name: "React Native / ReactJs",
  },
  {
    icon: <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />,
    name: "JavaScript",
  },
  {
    icon: <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />,
    name: "Git",
  },
  {
    icon: <FontAwesomeIcon icon={faCss3} color="#28A4D9" />,
    name: "Css3 / Scss",
  },
  {
    icon: <FontAwesomeIcon icon={faHtml5} color="#F06529" />,
    name: "HTML5",
  },
  {
    icon: <img src={Img} alt="TypeScript" className="img" />,
    name: "TypeScript",
  },
];

// Backend skills
const backendSkills = [
  {
    icon: <FontAwesomeIcon icon={faNode} color="#68A063" />,
    name: "Node.js",
  },
  {
    icon: <FontAwesomeIcon icon={faDatabase} color="#00758F" />,
    name: "MySQL",
  },
  {
    icon: <FontAwesomeIcon icon={faDatabase} color="#CC2927" />,
    name: "MS SQL Server",
  },
];

// API Development skills
const apiSkills = [
  {
    icon: <FontAwesomeIcon icon={faServer} color="#FF6B6B" />,
    name: "RESTful APIs",
    description: "Design and implementation of RESTful APIs with proper endpoints, HTTP methods, and status codes"
  },
  {
    icon: <FontAwesomeIcon icon={faShieldAlt} color="#4ECDC4" />,
    name: "Authentication",
    description: "JWT, OAuth2, API keys, and secure token-based authentication systems"
  },
  {
    icon: <FontAwesomeIcon icon={faDatabase} color="#45B7D1" />,
    name: "Database Integration",
    description: "CRUD operations, relationships, transactions, and optimized queries"
  },
  {
    icon: <FontAwesomeIcon icon={faExchangeAlt} color="#96CEB4" />,
    name: "API Documentation",
    description: "Comprehensive API documentation with examples using Postman, Swagger/OpenAPI"
  },
  {
    icon: <FontAwesomeIcon icon={faCode} color="#FFEAA7" />,
    name: "Middleware & Validation",
    description: "Request validation, error handling, logging, and security middleware"
  },
  {
    icon: <FontAwesomeIcon icon={faServer} color="#DDA0DD" />,
    name: "Performance Optimization",
    description: "Caching, pagination, rate limiting, and database query optimization"
  },
];

// Postman Collection Examples
const postmanExamples = [
  {
    method: "POST",
    endpoint: "/api/auth/register",
    description: "User Registration",
    request: {
      "email": "user@example.com",
      "password": "Securepassword123#",
      "name": "Mavine naaman"
    },
    response: {
      "success": true,
      "message": "User registered successfully",
      "data": {
        "userId": "123456",
        "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
      }
    }
  },
  {
    method: "POST",
    endpoint: "/api/auth/login",
    description: "User Login",
    request: {
      "email": "user@example.com",
      "password": "securepassword123"
    },
    response: {
      "success": true,
      "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
      "user": {
        "id": "123456",
        "name": "Mavine naaman",
        "email": "user@example.com"
      }
    }
  },
  {
    method: "GET",
    endpoint: "/api/users/profile",
    description: "Get User Profile",
    headers: {
      "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
    },
    response: {
      "success": true,
      "data": {
        "id": "123456",
        "name": "mavine naaman",
        "email": "user@example.com",
        "createdAt": "2024-01-15T10:30:00Z"
      }
    }
  },
  {
    method: "POST",
    endpoint: "/api/payments/create",
    description: "Create Payment",
    request: {
      "amount": 100.50,
      "currency": "USD",
      "description": "Service Payment"
    },
    headers: {
      "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
    },
    response: {
      "success": true,
      "paymentId": "pay_123456",
      "status": "pending",
      "paymentUrl": "https://payment.gateway.com/pay/pay_123456"
    }
  },
  {
    method: "GET",
    endpoint: "/api/projects?page=1&limit=10",
    description: "Get Projects with Pagination",
    response: {
      "success": true,
      "data": [
        {
          "id": "1",
          "name": "E-commerce API",
          "description": "Online shopping platform API",
          "status": "active"
        }
      ],
      "pagination": {
        "page": 1,
        "limit": 10,
        "totalPages": 5,
        "totalItems": 48
      }
    }
  },
  {
    method: "PUT",
    endpoint: "/api/users/profile/update",
    description: "Update User Profile",
    request: {
      "name": "John Smith",
      "phone": "+1234567890"
    },
    headers: {
      "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
    },
    response: {
      "success": true,
      "message": "Profile updated successfully",
      "data": {
        "name": "John Smith",
        "phone": "+1234567890"
      }
    }
  }
];

const Skills = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  const [activeTab, setActiveTab] = useState("frontend");
  
  const frontendArray = ["F", "r", "o", "n", "t", "e", "n", "d", " ", "S", "k", "i", "l", "l", "s"];
  const backendArray = ["B", "a", "c", "k", "e", "n", "d", " ", "S", "k", "i", "l", "l", "s"];
  const apiArray = ["A", "P", "I", " ", "D", "e", "v", "e", "l", "o", "p", "m", "e", "n", "t"];
  
  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  return (
    <>
      <div className="container skills-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={
                activeTab === "frontend" ? frontendArray : 
                activeTab === "backend" ? backendArray : 
                apiArray
              }
              idx={15}
            />
          </h1>
          
          {/* Tab Navigation */}
          <div className="skills-tabs">
            <button 
              className={`tab-btn ${activeTab === 'frontend' ? 'active' : ''}`}
              onClick={() => setActiveTab('frontend')}
            >
              Frontend
            </button>
            <button 
              className={`tab-btn ${activeTab === 'backend' ? 'active' : ''}`}
              onClick={() => setActiveTab('backend')}
            >
              Backend
            </button>
            <button 
              className={`tab-btn ${activeTab === 'apis' ? 'active' : ''}`}
              onClick={() => setActiveTab('apis')}
            >
              APIs & Postman
            </button>
          </div>
        </div>
        
        <div className="skills-container">
          {activeTab === "apis" ? (
            <div className="api-section">
              <div className="api-skills-grid">
                {apiSkills.map((skill, index) => (
                  <div className="api-skill-card" key={index}>
                    <div className="api-skill-icon">{skill.icon}</div>
                    <h3>{skill.name}</h3>
                    <p>{skill.description}</p>
                  </div>
                ))}
              </div>
              
              <div className="postman-section">
                <h2 className="postman-title">Postman API Examples</h2>
                <p className="postman-subtitle">Sample API endpoints I've developed and documented</p>
                
                <div className="api-examples-grid">
                  {postmanExamples.map((api, index) => (
                    <div className="api-example-card" key={index}>
                      <div className="api-method" data-method={api.method}>
                        {api.method}
                      </div>
                      <div className="api-endpoint">{api.endpoint}</div>
                      <div className="api-description">{api.description}</div>
                      
                      <div className="api-details">
                        {api.request && (
                          <div className="api-request">
                            <h4>Request Body:</h4>
                            <pre>{JSON.stringify(api.request, null, 2)}</pre>
                          </div>
                        )}
                        
                        {api.headers && (
                          <div className="api-headers">
                            <h4>Headers:</h4>
                            <pre>{JSON.stringify(api.headers, null, 2)}</pre>
                          </div>
                        )}
                        
                        <div className="api-response">
                          <h4>Response:</h4>
                          <pre>{JSON.stringify(api.response, null, 2)}</pre>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className="api-features">
                  <h3>Key API Features I Implement:</h3>
                  <div className="features-list">
                    <div className="feature">
                      <FontAwesomeIcon icon={faShieldAlt} />
                      <span>Authentication & Authorization</span>
                    </div>
                    <div className="feature">
                      <FontAwesomeIcon icon={faExchangeAlt} />
                      <span>Request Validation & Sanitization</span>
                    </div>
                    <div className="feature">
                      <FontAwesomeIcon icon={faDatabase} />
                      <span>Database Transactions & Relationships</span>
                    </div>
                    <div className="feature">
                      <FontAwesomeIcon icon={faServer} />
                      <span>Rate Limiting & Throttling</span>
                    </div>
                    <div className="feature">
                      <FontAwesomeIcon icon={faCode} />
                      <span>Error Handling & Logging</span>
                    </div>
                    <div className="feature">
                      <FontAwesomeIcon icon={faExchangeAlt} />
                      <span>WebSocket Support (Real-time)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="tips">
              {(activeTab === "frontend" ? frontendSkills : backendSkills).map((skill) => (
                <div className="skillsicon" key={skill.name}>
                  {skill.icon}
                  <span className="skillsName">{skill.name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <Loader type="pacman" />
    </>
  );
};

export default Skills;